import React, { useState } from 'react';
import { Modal } from '../games/gameBits';

// The squad's join code, copied with a click.
export default function SquadCodeModal({ code, onClose }) {
  const [toast, setToast] = useState('');
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setToast('Code copied');
    } catch (_error) {
      setToast('Could not copy the code.');
    }
  };
  return (
    <Modal label="Squad code" onClose={onClose} className="squad-code-dialog">
      <h2>Squad code</h2>
      <button type="button" className="squad-code" onClick={copy}>{code}</button>
      <p className="squad-code-hint">{toast || 'Click the code to copy it.'}</p>
      <div className="games-dialog-actions">
        <button type="button" className="games-btn is-primary" onClick={onClose}>Done</button>
      </div>
    </Modal>
  );
}
